export default __webpack_public_path__ + "static/media/Quit.9e3f07e4.jpg";